<script>
  export default {
    props: {
      customClass: {
        type: String,
        default: 'tw-fill-primary',
      },
      disableHover: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      width() {
        return 18
      },
      height() {
        return 16
      },
      viewBox(){
        return `0 0 ${this.width} ${this.height}`
      }
    },
  }
</script>

<template>
  <svg
    :class="[customClass, { 'no-hover': disableHover }]"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.7422 4.73583C11.6414 3.77073 11.0881 2.9393 10.299 2.44797C10.3198 1.09327 11.4306 0.000423012 12.7999 0C14.1824 0 15.3029 1.11273 15.3029 2.48562C15.3029 3.85829 14.1824 4.97102 12.7999 4.97102C12.4212 4.97102 12.064 4.88515 11.7422 4.73583ZM11.1622 5.05155C11.1622 6.42423 10.0417 7.53717 8.65918 7.53717C7.27689 7.53717 6.15573 6.42444 6.15573 5.05176C6.15573 3.67909 7.27689 2.56615 8.65918 2.56615C10.0415 2.56615 11.1622 3.67888 11.1622 5.05155ZM9.72092 7.70677H7.59701C5.82985 7.70677 4.39219 9.13465 4.39219 10.8895V13.4688L4.39879 13.5092L4.5777 13.5649C5.94819 13.9901 7.17254 14.185 8.2304 14.2431L8.18234 14.9729C8.18191 14.9835 8.18447 14.9935 8.18979 15.0017L8.81342 15.978C8.82215 15.9918 8.83727 16 8.85303 16H8.85431C8.87029 16 8.88477 15.9922 8.89393 15.9789L9.56526 15.0032C9.57123 14.9941 9.57442 14.9837 9.57314 14.9725L9.52192 14.2486C11.5164 14.1523 12.6631 13.5921 12.74 13.5532L12.9072 13.4693H12.9251V10.8895C12.9257 9.13465 11.4881 7.70677 9.72092 7.70677ZM9.52192 14.2486L9.2379 10.2346C9.23577 10.2094 9.2149 10.1904 9.18955 10.1904H8.54229C8.51673 10.1904 8.49607 10.2094 8.49436 10.2346L8.2304 14.2431C8.47427 14.2565 8.70928 14.2626 8.93521 14.2626C9.13819 14.2626 9.33383 14.2577 9.52192 14.2486ZM9.26156 10.047H8.49204L7.82305 8.67388C7.82305 8.54211 7.93039 8.43594 8.06308 8.43594H9.66965C9.80191 8.43594 9.90926 8.54211 9.90926 8.67388L9.26156 10.047ZM11.7545 5.14089H13.862C15.629 5.14089 17.0666 6.56855 17.0666 8.3232V10.9034H17.0487L16.8816 10.9875C16.8025 11.0269 15.6034 11.6125 13.5225 11.6883V10.8934C13.5225 9.18488 12.3733 7.73839 10.8025 7.27456C11.3718 6.73226 11.7317 5.97824 11.7545 5.14089ZM4.26722 4.97159C4.75688 4.97159 5.21246 4.82967 5.59839 4.58792C5.72107 3.79329 6.15003 3.09892 6.76279 2.62599C6.76356 2.61201 6.7645 2.59807 6.76544 2.58413C6.76763 2.55168 6.76982 2.51925 6.76982 2.4864C6.76982 1.11351 5.64908 0.00078125 4.26722 0.00078125C2.88451 0.00078125 1.76419 1.11351 1.76419 2.4864C1.76419 3.85865 2.88451 4.97159 4.26722 4.97159ZM5.56365 5.15273C5.58985 5.98501 5.94852 6.73501 6.51507 7.27456C4.94386 7.73881 3.79501 9.18488 3.79458 10.8934V11.6724C2.74583 11.6115 1.53841 11.4182 0.185512 10.9988L0.0066026 10.9427L0 10.9029V8.3232C0 6.56855 1.43766 5.14089 3.20482 5.14089H5.32851C5.40248 5.14089 5.47442 5.14617 5.5469 5.1515C5.55248 5.15191 5.55806 5.15232 5.56365 5.15273Z" />
  </svg>
</template>
